<template>
  <div class="stat-card" :class="{ 'is-compact': compact, 'is-ultra-compact': ultraCompact }">
    <div class="card">
      <div class="card-body">
        <skeleton-loader v-if="loading" />
        <div v-else class="d-flex align-items-center">
          <div class="icon-container" :class="`bg-light-${color}`">
            <feather-icon :icon="icon" :size="iconSize" :class="`text-${color}`" />
          </div>
          <div class="stat-content">
            <h6 class="stat-title">{{ title }}</h6>
            <h3 v-if="value !== null" class="stat-value">{{ value }}</h3>
            <p v-else class="stat-empty">{{ emptyText }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonLoader from './SkeletonLoader.vue';

export default {
  components: {
    SkeletonLoader
  },
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: [Number, String],
      default: null
    },
    emptyText: {
      type: String,
      default: 'No data available'
    },
    icon: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'primary'
    },
    loading: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    },
    ultraCompact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconSize() {
      if (this.ultraCompact) return '16';
      if (this.compact) return '18';
      return '20';
    }
  }
};
</script>

<style lang="scss" scoped>
.stat-card {
  .card {
    margin-bottom: 0;
    height: 100%;

    .card-body {
      padding: 1.5rem;
    }

    .icon-container {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 48px;
      border-radius: 50%;
      margin-right: 1.25rem;
    }

    .stat-content {
      .stat-title {
        margin-bottom: 0.5rem;
        font-size: 0.95rem;
        color: #6e6b7b;
      }

      .stat-value {
        margin-bottom: 0;
        font-size: 1.75rem;
        font-weight: 600;
      }

      .stat-empty {
        margin-bottom: 0;
        color: #b9b9c3;
      }
    }
  }

  &.is-compact {
    .card {
      .card-body {
        padding: 1.25rem;
      }

      .icon-container {
        width: 42px;
        height: 42px;
        margin-right: 1rem;
      }

      .stat-content {
        .stat-title {
          font-size: 0.9rem;
          margin-bottom: 0.35rem;
        }

        .stat-value {
          font-size: 1.5rem;
        }
      }
    }
  }

  &.is-ultra-compact {
    .card {
      .card-body {
        padding: 1rem;
      }

      .icon-container {
        margin-right: 0.75rem;
        width: 36px;
        height: 36px;
      }

      .stat-content {
        .stat-title {
          font-size: 0.85rem;
          margin-bottom: 0.25rem;
        }

        .stat-value {
          font-size: 1.25rem;
        }
      }
    }
  }
}
</style>
